import React from 'react';
import { useRecordContext } from 'react-admin';
import { Chip } from '@mui/material';
import { leadsFields } from '../leads.model';

const SmsOptInStatusField = () => {
    const record = useRecordContext();
    if (!record) return null;

    const smsOptIn = record[leadsFields.smsOptIn];

    // Show "Active" badge if SMS Opt-in has a value (true or any truthy value)
    if (smsOptIn) {
        return (
            <Chip
                label="Active"
                color="success"
                size="small"
                sx={{ mt: 1 }}
            />
        );
    }

    // Show "Inactive" badge if SMS Opt-in is false or null
    return (
        <Chip
            label="Inactive"
            color="default"
            size="small"
            sx={{ mt: 1 }}
        />
    );
};

export default SmsOptInStatusField;
